import ApexCharts from 'apexcharts'

const charts = document.querySelectorAll<HTMLElement>('.clm-apexchart-chart');
charts.forEach(chart => {
  if (!chart.dataset.options) return;
  const parsedOptions = JSON.parse(chart.dataset.options);
  const apexOptions = <ApexCharts.ApexOptions>parsedOptions;
  if (!apexOptions.chart) apexOptions.chart = {};
  if (!apexOptions.chart.type) apexOptions.chart.type = 'line';
  new ApexCharts(chart, apexOptions).render();
});

